const Terms = () => {
  const formattedDate = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  return (
    <div className="min-h-screen bg-background p-8 pt-24">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-6">Terms and Conditions</h1>
        <div className="prose dark:prose-invert">
          <p className="text-sm text-muted-foreground mb-8">Last updated: {formattedDate}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Introduction</h2>
            <p>
              Welcome to Sentiri Ltd ("Sentiri Ltd," "we," "our," or "us"). These Terms and Conditions govern your use 
              of our landing page, accessible at Sentiri.io. By using our website and signing up for our waitlist, 
              you agree to comply with these terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Use of the Website and Waitlist</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>You must be at least 18 years old to sign up for our waitlist.</li>
              <li>You agree to provide accurate and up-to-date information when signing up.</li>
              <li>Joining our waitlist does not guarantee access to our services or products.</li>
              <li>We reserve the right to modify or discontinue any part of the website or waitlist without prior notice.</li>
              <li>We may contact you via email regarding updates, offers, and company news. You can opt out at any time.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Intellectual Property</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>All content on this website, including text, graphics, and logos, is our property or the property of our licensors.</li>
              <li>You may not reproduce, distribute, or modify any content without our written consent.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Limitation of Liability</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>We are not responsible for any losses or damages resulting from your use of our website or waitlist.</li>
              <li>We do not guarantee that our website will always be available or free from viruses.</li>
              <li>We are not liable for any third-party links or services accessed through our website.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Data Protection and Privacy</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>We collect and process personal data in accordance with our Privacy Policy and GDPR regulations.</li>
              <li>By signing up, you consent to the collection and use of your data as outlined in our Privacy Policy.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Governing Law and Dispute Resolution</h2>
            <ul className="list-disc pl-6 mb-4">
              <li>These terms shall be governed by and construed in accordance with the laws of England and Wales.</li>
              <li>Any disputes shall be resolved through arbitration or the courts of England and Wales.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Changes to These Terms</h2>
            <p>
              We may update these Terms and Conditions from time to time. The latest version will always be 
              available on our website.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Contact Information</h2>
            <p>
              For any questions, please contact us at:{" "}
              <a href="mailto:enquiries@sentiri.io" className="text-[#00DC82] hover:underline">
                enquiries@sentiri.io
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;